export enum Enable {
    true = 'Sim',
    false = 'Não'
}